/* eslint-disable @typescript-eslint/no-unused-vars */
import { NavigateProps } from './types';

export const DefaultNavigate = ({ to, replace, state, relative }: NavigateProps): null => {
  return null;
};
